<script setup lang="ts">
import TheNavbar from '@/components/TheNavbar.vue';
import TheSidebar from '@/components/TheSidebar.vue';
import { SearchRow } from '@/components/browse';
import CartButton from '@/components/browse/header/CartButton.vue';

const { isMobile } = useScreenSize();
const route = useRoute();

const isMarketplace = computed(() => {
  return route.path === '/marketplace';
});

const isNavVisible = computed(() => {
  return isMarketplace.value || !isMobile.value;
});

const teleportSearch = computed(() => {
  return '#nav-search';
});
</script>

<template>
  <v-layout>
    <ClientOnly>
      <TheSidebar />
    </ClientOnly>

    <v-main :class="{ 'nav-hidden': !isNavVisible }" style="--v-layout-top: 64px">
      <TheNavbar v-show="isNavVisible" />

      <ClientOnly>
        <Teleport to="#cart-append">
          <CartButton />
        </Teleport>
      </ClientOnly>

      <ClientOnly>
        <Teleport v-if="isMarketplace || (!isMobile && !isMarketplace)" :to="teleportSearch" :disabled="isMobile">
          <SearchRow :class="{ 'search-mobile': isMobile }" />
        </Teleport>

        <template #placeholder>
          <SearchRow v-if="isMobile" :class="{ 'search-mobile': isMobile }" />
        </template>
      </ClientOnly>

      <NuxtPage :page-key="(route) => route.path" />
    </v-main>
  </v-layout>
</template>

<style lang="scss">
.nav-hidden {
  padding-top: 0px !important;
}

.search-mobile {
  padding-inline: 16px;
  padding-bottom: 8px;
  border-bottom: 0.5px solid rgb(var(--v-theme-stroke));
}
</style>
